$(() => {
    addAdsArea();
})

const addAdsArea = () => {
    lwhb.cmd.push(function() {
        if (typeof adValue != "undefined") {
            lwhb.adServerKeywords({'category':adValue});
        }
        adTags.forEach((id) => {
            if ($("#" + id).length > 0) {
                lwhb.loadAd({tagId: id});
            }
        });
    });
}